import PropTypes from 'prop-types';
import valuesIn from 'lodash/valuesIn';
import { OTP_METHODS, SCOPE_NAMES, IDENTITY_STATUSES } from './constants';
export const scopeName = PropTypes.oneOf(valuesIn(SCOPE_NAMES));
// const gender = PropTypes.oneOf(['Female', 'Male']);
export const account = PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    emailHash: PropTypes.string.isRequired,
    accountSource: PropTypes.string.isRequired
});
export const otpStatus = PropTypes.shape({
    method: PropTypes.oneOf(valuesIn(OTP_METHODS)).isRequired,
    identifierUID: PropTypes.string,
    identifier: PropTypes.string,
    lockoutEnd: PropTypes.number
});
export const scope = PropTypes.shape({
    scopeId: PropTypes.number.isRequired,
    scope: scopeName.isRequired,
    nameKey: PropTypes.string.isRequired
});
export const identityProvider = PropTypes.shape({
    identityProviderId: PropTypes.number.isRequired,
    identityProviderKey: PropTypes.string.isRequired,
    identityProviderType: PropTypes.string.isRequired,
    nameKey: PropTypes.string.isRequired,
    countries: PropTypes.arrayOf(PropTypes.string).isRequired,
    scopes: PropTypes.arrayOf(scopeName).isRequired
});
export const identityProviderType = PropTypes.oneOf([
    'Aid',
    'ContourCloud',
    'CNC',
    'Draft'
]);
export const identity = PropTypes.shape({
    identityUID: PropTypes.string.isRequired,
    identityProviderType,
    identityProviderKey: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    status: PropTypes.oneOf(valuesIn(IDENTITY_STATUSES)).isRequired,
    scope: scopeName.isRequired
});
export const identityRequirements = PropTypes.shape({
    scope: scopeName,
    email: PropTypes.string,
    countryCode: PropTypes.string
});
export const invitation = PropTypes.shape({
    invitationCode: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    scope: scopeName.isRequired,
    allowedScopes: PropTypes.arrayOf(scopeName),
    allowedCountries: PropTypes.arrayOf(PropTypes.string),
    information: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        dateOfBirth: PropTypes.string
    }),
    inviter: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        organizationName: PropTypes.string
    }).isRequired,
    keys: PropTypes.shape({})
});
